export const CREATE_AGENT_START='CREATE_AGENT_START';
export const CREATE_AGENT_SUCCESS='CREATE_AGENT_SUCCESS';
export const CREATE_AGENT_FAIL='CREATE_AGENT_FAIL';

export const GET_AGENTS_START='GET_AGENT_START';
export const GET_AGENTS_SUCCESS='GET_AGENT_SUCCESS';
export const GET_AGENTS_FAIL='GET_AGENT_FAIL';

export const UPDATE_AGENT_START='UPDATE_AGENT_START';
export const UPDATE_AGENT_SUCCESS='UPDATE_AGENT_SUCCESS';
export const UPDATE_AGENT_FAIL='UPDATE_AGENT_FAIL';

export const SET_COMMISSION_TO_UPDATE='SET_COMMISSION_TO_UPDATE';

export const TOGGLE_BASIC_INFO_UPDATE='TOGGLE_BASIC_INFO_UPDATE';
export const TOGGLE_BET_LIMIT_UPDATE='TOGGLE_BET_LIMIT_UPDATE';
export const TOGGLE_COMMISSION_UPDATE='TOGGLE_COMMISSION_UPDATE';
export const TOGGLE_SHARE_DETAIL_UPDATE='TOGGLE_SHARE_DETAIL_UPDATE';
export const TOGGLE_SINGLE_BET_COMMISSION_UPDATE='TOGGLE_SINGLE_BET_COMMISSION_UPDATE';
export const TOGGLE_SINGLE_BET_UPDATE='TOGGLE_SINGLE_BET_UPDATE';
export const TOGGLE_EXTRA_COMMISSION_UPDATE='TOGGLE_EXTRA_COMMISSION_UPDATE';
export const TOGGLE_2D_COMMISSION_UPDATE='TOGGLE_2D_COMMISSION_UPDATE';
export const TOGGLE_3D_COMMISSION_UPDATE='TOGGLE_3D_COMMISSION_UPDATE';
export const TOGGLE_4D_COMMISSION_UPDATE='TOGGLE_4D_COMMISSION_UPDATE';

export const GET_ONE_AGENT_START='GET_ONE_AGENT_START';
export const GET_ONE_AGENT_SUCCESS='GET_ONE_AGENT_SUCCESS';
export const GET_ONE_AGENT_FAIL='GET_ONE_AGENT_FAIL';

export const UPDATE_SUSPEND_START='UPDATE_SUSPEND_START';
export const UPDATE_SUSPEND_SUCCESS='UPDATE_SUSPEND_SUCCESS';
export const UPDATE_SUSPEND_FAIL='UPDATE_SUSPEND_FAIL';

export const RESET_PASSWORD_START='RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS='RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL='RESET_PASSWORD_FAIL';
export const TOGGLE_RESET_PASSWORD_MODAL='TOGGLE_RESET_PASSWORD_MODAL';


export const UPDATE_AGENT_BALANCE='UPDATE_AGENT_BALANCE';
